module.exports = __webpack_public_path__ + "media/auth/login-background-old-6e2748e2.jpg";